import { FileView, HttpError, UserView } from 'gallerydigitalassets-v1-client'
import { assetFileApi, axiosFileMetadataClient, axiosGalleryEventsClient, galleryAxiosClient } from '../client'
import axios from 'axios'
import { processError } from '../utils'
import { IAsset } from 'store/asset'
import { v4 as uuidv4 } from 'uuid'

// TODO: MOVE THIS INTO CLIENT STORE AND MAKE ALTERABLE FROM ANY STORE FOR CANCELABLE CALLS
// This allows search to be cancelable if another search call is made
let call: any

export const updateFileAPI = async (
  xTgtLanId: string,
  assetId: string,
  fileId: string,
  fileName?: string,
  heroImage?: boolean
) => {
  try {
    const { body } = await assetFileApi.updateAssetFile(assetId, fileId, xTgtLanId, fileName, heroImage)
    if (body.data) {
      return body.data as FileView
    }
  } catch (error: any) {
    if (error instanceof HttpError) {
      throw error
    } else {
      processError(error)
    }
  }
}

export const downloadMultipleFilesAPI = async (xTgtLanId: string, assetId: string, fileIds: string) => {
  if (call) {
    call.cancel('Cancelling earlier download request')
  }
  call = axios.CancelToken.source()
  const response = await galleryAxiosClient.get(`/assets/${assetId}/files/downloads?file_ids=${fileIds}`, {
    cancelToken: call.token,
  })
  const preSignedUrl = response.data.data.pre_signed_url
  const link = document.createElement('a')
  link.href = preSignedUrl
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadFileAPI = async (xTgtLanId: string, fileSignedUrl: string) => {
  const link = document.createElement('a')
  link.href = fileSignedUrl
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const deleteFileAPI = async (xTgtLanId: string, fileIds: string[], assetId: string) => {
  try {
    await assetFileApi.deleteAssetFile(assetId, fileIds, xTgtLanId)
  } catch (error: any) {
    if (error instanceof HttpError) {
      throw error
    } else {
      processError(error)
    }
  }
}

export const setAssetThumbnailApi = async (xTgtLanId: string, fileId: string, assetId: string) => {
  try {
    await assetFileApi.updateAssetFile(assetId, fileId, xTgtLanId, undefined, true, undefined)
  } catch (error: any) {
    if (error instanceof HttpError) {
      throw error
    } else {
      processError(error)
    }
  }
}

export const getFileMetadataBulkApi = async (fileMetadataServer: string, fileId: string) => {
  try {
    return axiosFileMetadataClient.post(`${fileMetadataServer}/fetch-metadata-bulk`, {
      source_ids: [fileId],
      source: 'gallery',
    })
  } catch (error: any) {
    if (error instanceof HttpError) {
      throw error
    } else {
      processError(error)
    }
  }
}

export const extractFileMetadataApi = async (fileMetadataServer: string, fileId: string, accessUrl: string) => {
  try {
    return axiosFileMetadataClient.post(`${fileMetadataServer}/metadata/extract`, {
      file_details: [
        {
          presigned_url: accessUrl,
          source_id: fileId,
        },
      ],
      source: 'gallery',
    })
  } catch (error: any) {
    if (error instanceof HttpError) {
      throw error
    } else {
      processError(error)
    }
  }
}

export const sendFileMetrics = async (
  galleryEventsServer: string,
  fileMetadataMetricsTopic: string,
  fileId: string,
  fileName: string,
  fileExtension: string,
  fileSize: string,
  assetInfo: IAsset | undefined,
  userInfo: UserView | null,
  eventName: string,
  eventType: string = 'METADATA'
) => {
  try {
    const metricsData = JSON.stringify({
      event_id: uuidv4(),
      file_id: fileId,
      file_name: fileName,
      file_extension: fileExtension,
      file_size: fileSize,
      taxonomy_name: assetInfo?.assetTaxonomy.name || assetInfo?.taxonomyId,
      event_user_id: userInfo?.lanId,
      event_name: eventName,
      event_type: eventType,
      event_timestamp: new Date().toISOString().replace(/[T,Z]/g, ' ').trim().split('.')[0],
    })
    return axiosGalleryEventsClient.post(`${galleryEventsServer}${fileMetadataMetricsTopic}`, {
      key: fileId,
      value: metricsData,
    })
  } catch (error: any) {
    if (error instanceof HttpError) {
      throw error
    } else {
      processError(error)
    }
  }
}
